export default function Introduction() {
  return (
    <section className="py-24 px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="w-full h-[600px]">
            <img 
              src="https://readdy.ai/api/search-image?query=Luxurious%20hotel%20interior%20lobby%20with%20contemporary%20art%20deco%20design%20featuring%20elegant%20marble%20floors%20modern%20chandeliers%20plush%20seating%20areas%20and%20sophisticated%20neutral%20color%20palette%20with%20gold%20accents%20showcasing%20refined%20Parisian%20luxury%20hospitality&width=800&height=1000&seq=intro001&orientation=portrait"
              alt="Hotel Interior"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="space-y-6">
            <p className="text-sm tracking-widest text-gray-500 uppercase">洗練の邸宅</p>
            <h3 className="text-4xl md:text-5xl font-serif text-gray-900 leading-tight">
              日本の美意識が息づく、<br />唯一無二の空間
            </h3>
            <p className="text-gray-600 leading-relaxed text-base">
              東京・大手町。皇居の緑を望むこの地に、The Azalea Tokyoは静かに佇みます。喧騒から離れた特別な場所で、日本のおもてなしの真髄をお届けいたします。
            </p>
            <p className="text-gray-600 leading-relaxed text-base">
              全室スイート仕様の客室、ミシュランの星を冠するレストラン、そして五感を解き放つスパ。すべてが、お客様だけの特別な時間のために設えられています。
            </p>
            <p className="text-gray-600 leading-relaxed text-base">
              お名前を覚え、お好みを心に留め、語られぬ願いをも叶える。私どものおもてなしは、お客様との対話から始まります。
            </p>
            <button className="mt-6 px-8 py-3 border border-gray-900 text-gray-900 text-sm tracking-wide whitespace-nowrap hover:bg-gray-900 hover:text-white transition-all">
              詳しく見る
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}